import { ChangeDetectionStrategy, Component, input } from '@angular/core';

/**
 * Par etiqueta / valor. Sustituye a los tres markups que convivían para lo
 * mismo: `detail-item` (expediente), `detalle-grid-item` (modales de solicitud)
 * e `info-row` (`<strong>` + `<span>` a mano).
 *
 * El valor va por contenido proyectado, así que admite texto, un `<nz-tag>` o
 * lo que haga falta:
 *
 * ```html
 * <app-detail-field label="ID Interno">{{ emp.idInterno }}</app-detail-field>
 * <app-detail-field label="Estatus"><nz-tag>Activo</nz-tag></app-detail-field>
 * ```
 *
 * `layout` no es capricho: en un expediente ancho la fila horizontal se lee
 * mejor, y en un modal angosto el apilado evita que la etiqueta se coma el
 * espacio del valor. Lo homologado son los tokens y el markup, no forzar un
 * único layout.
 */
@Component({
  selector: 'app-detail-field',
  template: `
    <div
      class="df"
      [class.df--stacked]="layout() === 'stacked'"
      [class.df--sm]="size() === 'sm'"
      [class.df--full]="full()"
    >
      <span class="df-label">{{ label() }}</span>
      <span class="df-value" [class.df-value--mono]="mono()" [class.df-value--money]="money()">
        <ng-content />
      </span>
    </div>
  `,
  styleUrl: './detail-field.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DetailField {
  readonly label = input.required<string>();
  /** `row` (default) para expedientes y listas de datos; `stacked` para modales angostos. */
  readonly layout = input<'row' | 'stacked'>('row');
  /** `sm` para las filas densas de los arrays (pagadoras, estudios, contactos). */
  readonly size = input<'md' | 'sm'>('md');
  /** Ocupa el ancho completo y respeta los saltos de línea del valor. */
  readonly full = input(false);
  /** Monoespaciado, para RFC / CURP / CLABE. */
  readonly mono = input(false);
  /** Antepone el símbolo de moneda. */
  readonly money = input(false);
}
